/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $(function(){
// 	$('.accordionButton').click(function(){
// 		if ($(this).attr('aria-expanded') == 'false') {
// 			$(this).attr('aria-expanded', true);
// 			$(this).next().slideDown();
// 		} else {
// 				$(this).attr('aria-expanded', false);
// 				$(this).next().slideUp();
// 		}
// 	});
// });





document.addEventListener('DOMContentLoaded', function() {
	// アコーディオンボタンに対するクリックイベントリスナーを設定
	document.querySelectorAll('.accordionButton').forEach(function(button) {
			button.addEventListener('click', function() {
					// aria-expanded属性をチェック
					if (this.getAttribute('aria-expanded') == 'false') {
							this.setAttribute('aria-expanded', 'true');
							this.nextElementSibling.style.display = 'grid'; // 次の要素を表示
							this.nextElementSibling.style.height = 'auto';
					} else {
							this.setAttribute('aria-expanded', 'false');
							this.nextElementSibling.style.display = 'none'; // 次の要素を非表示
							this.nextElementSibling.style.height = '0';
					}
			});
	});
});